import * as React from 'react'
import * as Raven from 'raven-js'
import ErrorPage from './../ErrorPage'

interface State {
  error: Error | undefined
  info: object | undefined
}

class ErrorBoundary extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props)
    this.state = {
      error: undefined,
      info: undefined,
    }
  }

  public componentDidCatch(error: Error, info: object) {
    this.setState({
      error,
      info,
    })
    Raven.captureException(error, { extra: info })
  }

  public render() {
    const { error } = this.state
    const { children } = this.props
    return error === undefined ? (
      children
    ) : (
      <ErrorPage message={error.toString()} />
    )
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.tsx